import './progress-bar.scss'
const ProgressBar = ({ percent, children }) => {
  return (
    <div className="progress">
      <div className="bar" style={{ width: `${percent}%` }}>
        {children}
      </div>
    </div>
  )
}

export default ProgressBar
